import * as actionTypes from '../actions/actionTypes';

const initState = {
  orders: [],
  loading: false,
  purchased: false
}

const purchaseOrderSuccess = (state, action) => {
  const newOrder = {
    id: action.orderId,
    ...action.orderData
  }
  return {
    ...state,
    loading: false,
    orders: state.orders.concat(newOrder),
    purchased: true
  }
}

const reducer = (state = initState, action) => {
  switch (action.type) {
    case actionTypes.PURCHASE_INIT: return { ...state, purchased: false };
    case actionTypes.PURCHASE_ORDER_START: return { ...state, loading: true };
    case actionTypes.PURCHASE_ORDER_SUCCESS: return purchaseOrderSuccess(state, action);
    case actionTypes.PURCHASE_ORDER_FAIL: return { ...state, loading: false };
    case actionTypes.FETCH_ORDERS_START: return { ...state, loading: true };
    case actionTypes.FETCH_ORDERS_SUCCESS: return { ...state, orders: action.orders, loading: false };
    case actionTypes.FETCH_ORDERS_FAIL: return { ...state, loading: false };
    default: return state
  }
};

export default reducer;